import { render, staticRenderFns } from "./Page404Notfound.vue?vue&type=template&id=2fb84970&scoped=true&"
import script from "./Page404Notfound.vue?vue&type=script&lang=js&"
export * from "./Page404Notfound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb84970",
  null
  
)

export default component.exports